// extracted by mini-css-extract-plugin
export var collapsedSummary = "_lm-0";